import styled from 'styled-components';
import { SuiErrorText } from '@splashthat/sui';

export const DateRangeContainer = styled.div`
    padding: 0 1rem;
`;

export const DateRangeSection = styled.div`
    padding: 1em 0;
`;

export const DateRangeError = styled(SuiErrorText)`
    position: absolute;
`;

export const TimeRangeError = DateRangeError;
